import { Box, Heading, VStack, Text, Button } from "@chakra-ui/react";
import { PaymentSuccessIllustrationSVG } from "assets";
import { WarningText } from "components";
import { when } from "utils";

interface IProps {
  status: string;
  lastStatus: {
    current: string;
  };
  handleContinue: () => void;
}
const SuccessUI = ({ status, lastStatus, handleContinue }: IProps) => {
  return (
    <Box>
      <VStack color="black" my={{ base: "16px", mb: "40px" }} bg="#F2F4F3" borderRadius="10px" p="20px">
        <Box borderRadius="50%" bg="#E8C229" boxSize="104px" display="flex" justifyContent="center" alignItems="center">
          <Box as={PaymentSuccessIllustrationSVG} />
        </Box>

        <Heading my="30px !important" as="h4" fontSize="32px" textTransform="capitalize">
          {status}!
        </Heading>
        <Text fontWeight="500">KYC Status: {status}</Text>
      </VStack>

      {lastStatus.current !== "pending" ? (
        <VStack my={{ base: "16px !important", mb: "40px !important" }}>
          <Button
            mt="20px !important"
            minW={{ base: "auto", "2sm": "400px" }}
            fontWeight="500"
            isDisabled={when(lastStatus.current === "pending", true, false)}
            onClick={handleContinue}
          >
            {when(["rejected", "expired"].includes(lastStatus.current), "Redo KYC", "Continue")}
          </Button>
        </VStack>
      ) : null}

      {status === "pending" && (
        <WarningText>
          <Text mb="6px">We are verifying your KYC.</Text>
          <Text>
            Anticipated completion time is{" "}
            <Text as="span" fontWeight="600">
              10 - 60 minutes
            </Text>
            . Feel free to close this page; we'll notify you via email about the verification status.
          </Text>
        </WarningText>
      )}
    </Box>
  );
};
export default SuccessUI;
